import { Link } from "react-router-dom";
import { Mic } from "lucide-react";

export const CoachUpsellNote = ({ testId = "coach-upsell-note" }) => (
  <div className="mt-3 flex items-start gap-2 p-3 rounded-lg border border-[#2A2E39] bg-[#14161B] text-left" data-testid={testId}>
    <Mic size={15} className="text-[#FD0F10] mt-0.5 shrink-0" />
    <p className="text-xs text-gray-300 flex-1">
      Tired of typing? Upgrade to Pro to talk with your coach by voice, get more coaching each day, and unlock more side hustle paths.{" "}
      <Link to="/pro" className="text-[#FD0F10] font-bold underline" data-testid={`${testId}-link`}>Upgrade</Link>
    </p>
  </div>
);
